import React, { FC } from 'react'
import { ArticleAbstractProps } from '@sport1/types/web'
import Font from '@sport1/news-styleguide/Font'
import { ResponsiveType } from '@sport1/react-elements/Types'
import { sport1Bold } from '@/helpers/fonts'

type Props = {
    content: ArticleAbstractProps
    displayArray: ResponsiveType<'inline' | 'none'>
}
const ArticleAbstract: FC<Props> = ({ content, displayArray }) => {
    return (
        <Font
            fontVariant="Title-M"
            fontFamilyVariant="Sport1-Bold"
            nextFontFamilyVariant={sport1Bold.style.fontFamily}
            marginBottom={['spacing-9', 'spacing-9', 'spacing-11']}
            testID="article-abstract"
            data-speakable="article-abstract"
            display={displayArray}
        >
            {content.text}
        </Font>
    )
}

export default ArticleAbstract
